import { SxProps, Theme } from '@mui/material/styles';

export const appStyles = {
    accessDenied: {
        textAlign: 'center',
        py: 8,
    } satisfies SxProps<Theme>,
};
